export const MIN_ELIGIBLE_AGE = 18;
export const MAX_ELIGIBLE_AGE = 65;
export const MAX_POLICY_AGE = 74;
export const MIN_TERM = 5;
export const MAX_TERM = 30;
export const MIN_COVERAGE = 50000;
export const MAX_COVERAGE = 600000;
